import React, { useCallback, useEffect, useMemo, useRef, useState, memo } from "react";
import "../RegisteredUser/ToggleSwitch.css";
import { Button, Row } from "react-bootstrap";
import "../RegisteredUser/MyMachinePage.css";
import instance, { apiEncryptRequest, decryptData } from "../../Api";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../common/Loader";
import { FaX } from "react-icons/fa6";
import toast, { Toaster } from "react-hot-toast";
import AppToast from "../../AppToast";
import { useDropdown } from "../Header";

// ─── Pure helpers ─────────────────────────────────────────────────────────────
const isMobileDevice = () => window.matchMedia("(max-width: 800px)").matches;

// ─── Shared constants ─────────────────────────────────────────────────────────
const PROCESSING_MSG = "Server configuration in Progress.\nPlease Return after 15 Minutes from the Creation Time...";

const vmCategoryLabel = (item) => {
  const prefix = item.vm_type === 1 ? "PortGate " : "Cloud ";
  const cat = item.vm_config_category;
  if ([1, 5, 6].includes(cat))  return `${prefix} Standard`;
  if ([3, 7, 8].includes(cat))  return `${prefix} CPU Int.`;
  if ([4, 9, 10].includes(cat)) return `${prefix} RAM Int.`;
  return "";
};

const diskGB = (item) =>
  item.disk_type === "ssd" ? item.ssd : item.disk_type === "nvme" ? item.nvme : item.hard_disk;

// ─── Shared sub-components ────────────────────────────────────────────────────

// IP field with loading indicator
const IpField = memo(({ label, value }) =>
  value !== null ? (
    <div className="machine-ip" style={{ marginTop: 8 }}>{label}: {value}</div>
  ) : (
    <div className="machine-ip" style={{ marginTop: 10, display: "flex", marginBottom: -10 }}>
      <a style={{ marginLeft: "-30%" }}>{label}:</a>
      <p className="loader-ip" style={{ height: 12, marginTop: 1, marginLeft: 5 }} />
    </div>
  )
);

// Action button (View Status / Monitor)
const ActionBtn = memo(({ label, onClick, dimOnProcessing, isProcessing, isPublicIpNull }) => (
  <div className="log-in" style={{ marginBottom: 6, marginTop: 8 }} onClick={onClick}>
    <a className="media-link">
      <div className="media-banner" style={{ minWidth: "6rem", marginTop: 5 }}>
        <img className="normal-banner" src="/admin/images/admin/wallet/add-money-btn.png" alt="" style={{ width: "6rem" }} />
        <img className="hover-img-banner"
          src={dimOnProcessing ? (isProcessing ? "/admin/images/admin/wallet/add-money-btn.png" : "/admin/images/admin/wallet/recharge-btn.png") : (isPublicIpNull ? "/admin/images/admin/wallet/add-money-btn.png" : "/admin/images/admin/wallet/recharge-btn.png")}
          alt="" />
        <span className="login-text" style={{ color: "white", fontSize: 14, marginTop: 0, fontWeight: 600 }}>{label}</span>
      </div>
    </a>
  </div>
));

// Search bar
const SearchBar = memo(({ value, onChange, isMobile }) => (
  <div className="input-container" style={{ marginLeft: isMobile ? undefined : "85%", position: "relative", border: "2px solid #035189", width: isMobile ? undefined : "15rem", marginTop: isMobile ? undefined : -72, height: isMobile ? undefined : 55 }}
    {...(isMobile ? { className: "input-container input-container-1" } : {})}>
    <input type="text" name="search" className="input-signup input-tickets" placeholder="Search Machine" value={value}
      style={{ fontSize: isMobile ? 18 : 24, color: "black", textAlign: "center", width: 10 }}
      onChange={(e) => onChange(e.target.value)} />
    {value && (
      <button style={{ backgroundColor: "transparent", border: "none" }} onClick={() => onChange("")}>
        <FaX style={{ marginBottom: 2, color: "#154e7a", fontSize: 19 }} />
      </button>
    )}
  </div>
));

// VNC popup — identical between mobile + web (only position differs)
const VNCPopup = memo(({ vNCinfo, isMobile, onClose }) => (
  <div style={{ content: "", top: 0, left: 0, right: 0, position: "fixed", width: "100%", height: "100vh", backgroundColor: "rgba(0,0,0,0.5)", zIndex: isMobile ? 999999999999 : 9999999 }}>
    <div style={{ position: "relative" }}>
      <div>
        <img src="/admin/images/admin/transaction-failed/transaction-failed-bg.png"
          style={{ width: "25rem", height: "15rem", position: "absolute", marginTop: isMobile ? "45%" : "20%", left: "50%", transform: "translate(-50%,-50%)" }} />
        <div style={{ position: "relative", zIndex: 1, padding: "2.5rem 1.5rem" }}>
          <div onClick={onClose}>
            <FaX style={{ position: "absolute", top: isMobile ? "15%" : "54%", right: isMobile ? "5%" : "39%", color: "#fff", fontSize: "1.5rem" }} />
          </div>
          {vNCinfo && (
            <div style={{ position: "relative", marginLeft: isMobile ? "20%" : "45%", marginTop: isMobile ? "23%" : "15%" }}>
              <span style={{ color: "#154e7a", fontSize: 24, fontWeight: 600 }}>
                PORT : {vNCinfo.port}<br />IP : {vNCinfo.ip}<br />PASSWORD : {vNCinfo.password}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
));

// Edit popup — only layout differs mobile vs web
const EditPopup = memo(({ isMobile, onClose, onEditOS, onEditConfig }) => {
  const figureStyle = { width: 100, height: 100, background: "rgb(233,119,48)", borderRadius: "50%", objectFit: "cover", margin: "auto", padding: 20, outline: "3px solid rgb(233,119,48)", border: "5px solid white" };
  const btnStyle    = { marginTop: 2, zIndex: 9, position: "relative", fontWeight: 700, color: "white", height: 55, backgroundColor: "#e97730", outline: "4px solid #e97730", border: "4px solid white", borderRadius: 30 };

  return (
    <div style={{ top: "10%", left: isMobile ? "3%" : "25%", position: "absolute", zIndex: 9, width: isMobile ? "27rem" : "70rem", backdropFilter: "blur(5px)", height: isMobile ? "20rem" : "40rem", borderRadius: 12, border: "2px solid #e97730" }}>
      <button style={{ zIndex: 9, position: "absolute", backgroundColor: "transparent", border: "none", right: 0 }} onClick={onClose}>
        <FaX style={{ marginBottom: 2, color: "#e97730", fontSize: 19 }} />
      </button>
      <div style={{ position: "relative", marginLeft: isMobile ? "10%" : "25%", marginTop: "23%", display: "flex", flexWrap: "nowrap", flexDirection: "row", gap: isMobile ? "3%" : "20%" }}>
        <div>
          <figure style={figureStyle}><img src="/images/admin/01-home/cpu.svg" alt="" style={{ marginLeft: -5, width: 60, height: 60 }} /></figure>
          <button style={{ ...btnStyle, width: isMobile ? "10rem" : "12rem" }} onClick={onEditOS}>Edit OS</button>
        </div>
        <div>
          <figure style={figureStyle}><img src="/admin/images/admin/menu/vm-white.png" alt="" style={{ marginLeft: -5, width: 60, height: 60 }} /></figure>
          <button style={{ ...btnStyle, width: isMobile ? "10rem" : "12rem" }} onClick={onEditConfig}>Edit Config</button>
        </div>
      </div>
    </div>
  );
});

// Delete confirmation popup
const DeletePopup = memo(({ isMobile, onConfirm, onCancel }) => (
  <div style={{ top: isMobile ? undefined : "7%", left: isMobile ? undefined : "40%", position: isMobile ? undefined : "absolute", zIndex: 9, width: "27rem", backdropFilter: "blur(5px)", height: "20rem", borderRadius: 12, border: "2px solid #e97730" }}
    className={isMobile ? "delete-popup-div-1" : undefined}>
    <button style={{ zIndex: 9, position: "absolute", backgroundColor: "transparent", border: "none", right: 0 }} onClick={onCancel}>
      <FaX style={{ marginBottom: 2, color: "#e97730", fontSize: 19 }} />
    </button>
    <h5 style={{ color: "#09528a", textAlign: "center", position: "absolute", marginTop: "5rem" }}>
      Do you Really Want to DELETE the Machine?
    </h5>
    <div style={{ position: "relative", marginLeft: "10%", marginTop: "45%", display: "flex", flexWrap: "nowrap", flexDirection: "row", gap: "3%" }}>
      <button className={isMobile ? "delete-popup-yes-btn-1" : undefined}
        style={isMobile ? undefined : { width: "10rem", marginTop: 2, zIndex: 9, position: "relative", fontWeight: 700, color: "white", height: 55, backgroundColor: "#aaa", outline: "4px solid #aaa", border: "4px solid white", borderRadius: 30 }}
        onClick={onConfirm}>YES</button>
      <button className={isMobile ? "delete-popup-no-btn-1" : undefined}
        style={isMobile ? undefined : { width: "10rem", marginTop: 2, zIndex: 9, position: "relative", fontWeight: 700, color: "white", height: 55, backgroundColor: "#e97730", outline: "4px solid #e97730", border: "4px solid white", borderRadius: 30 }}
        onClick={onCancel}>NO</button>
    </div>
  </div>
));

// ─── Main Component ───────────────────────────────────────────────────────────
const AssignedMachinePage = () => {
  const navigate      = useNavigate();
  const location      = useLocation();
  const { dropdownValue } = useDropdown();
  const selectedUser  = location.state?.userDetail ?? null;

  const [isMobile, setIsMobile]           = useState(isMobileDevice);
  const [loading, setLoading]             = useState(false);
  const [machineData, setMachineData]     = useState(null);
  const [machineUser, setMachineUser]     = useState(null);
  const [vNCinfo, setVNCinfo]             = useState(null);
  const [vncPopup, SetVncPopup]           = useState(false);
  const [editPopup, SetEditPopup]         = useState(false);
  const [deletePopup, SetDeletePopup]     = useState(false);
  const [showPlaceholder, SetShowPlaceholder] = useState(false);
  const [searchText, setSearchText]       = useState("");
  const [editMachineId, setEditMachineId] = useState("");
  const [machineToDelete, setMachineToDelete] = useState(null);
  const [deletingMachine, setDeletingMachine] = useState("");
  const [isHovered, setIsHovered]         = useState(false);
  const [shownOnce, setShownOnce]         = useState(false);
  const [isActive, setIsActive]           = useState(false);
  const [seconds, setSeconds]             = useState(51);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [machineActiveTime, setMachineActiveTime] = useState("");
  const [showTermsCondition, setShowTermsCondition] = useState(false);
  const [slaDesc, setSLADesc]             = useState(null);
  const [slaId, setSLAid]                 = useState(null);
  const [myMachineId, setMyMachineId]     = useState(null);
  const [isProfileVerified, setProfileVerified] = useState(null);

  // ── Toast helper ─────────────────────────────────────────────────────────
  const showToast = useCallback((msg) =>
    toast((t) => <AppToast id={t.id} message={msg} isMobile={isMobile} />),
    [isMobile]);

  // ── API helpers ───────────────────────────────────────────────────────────
  const apiPost = useCallback(async (url, payload) => {
    const enc = await apiEncryptRequest(payload);
    const res = await instance.post(url, enc);
    return decryptData(res.data);
  }, []);

  // ── Fetch machines ────────────────────────────────────────────────────────
  const GetMachines = useCallback(async () => {
    setLoading(true);
    try {
      const data = await apiPost("/childuserlist", { user_id: selectedUser.id });
      const vm = data.vm;
      setMachineUser(data.user);
      const vmArray = Object.values(vm);
      const processing = vmArray.find((i) => i.current_action_status === "PROCESSING");
      if (processing) { setIsActive(true); }
      SetShowPlaceholder(vmArray.length === 0);
      setMachineData(vmArray);
      GetMyDetails();
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [selectedUser?.id, apiPost]);

  // ── Profile verification check ────────────────────────────────────────────
  const GetMyDetails = useCallback(async () => {
    try {
      const res  = await instance.post("/editprofile", { user_id: selectedUser.id });
      const User = res.data.user;
      const indiaVerified = User.country === "India"
        ? (User.gst_verify === 1 || User.aadhar_verify === 1 || User.pan_verify === 1 || User.driving_verify === 1 || User.ciib_verify === 1)
        : User.identity_verify === 1;
      if (indiaVerified) setProfileVerified(true);
    } catch { }
  }, [selectedUser?.id]);

  // ── Background status polling ─────────────────────────────────────────────
  const bgUpdate = useCallback(async () => {
    const payload = { user_id: selectedUser.id };
    await Promise.allSettled([
      apiPost("/updatevmstatus",     payload),
      apiPost("/updatestatus",       payload),
      apiPost("/updatenetworkstatus",payload),
    ]);
    GetMachines();
  }, [selectedUser?.id, apiPost, GetMachines]);

  // ── Mount — fixed [isMobile] dep bug
  // Fix: original had [isMobile] as dep — caused GetMachines() + setTimeout(GetMachines, 5000)
  // to re-fire on every window resize event. Changed to [] — runs once only.
  useEffect(() => {
    GetMachines();
    const interval = setInterval(bgUpdate, 30000);
    const handleResize = () => setIsMobile(isMobileDevice());
    window.addEventListener("resize", handleResize);
    return () => { clearInterval(interval); window.removeEventListener("resize", handleResize); };
  }, []);

  // ── Scroll restore ────────────────────────────────────────────────────────
  useEffect(() => {
    const onScroll = () => setScrollPosition(window.scrollY);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { window.scrollTo(0, scrollPosition); }, [scrollPosition]);

  // ── MachineActiveTime from localStorage ───────────────────────────────────
  useEffect(() => {
    const stored = localStorage.getItem("machineTime");
    if (stored) {
      const t = new Date(stored);
      t.setMinutes(t.getMinutes() + 30);
      setMachineActiveTime(t.toISOString());
    }
  }, []);

  // ── Countdown timer ───────────────────────────────────────────────────────
  useEffect(() => {
    if (!isActive || seconds <= 0) {
      if (seconds === 0) { setShownOnce(true); GetMachines(); }
      return;
    }
    const id = setInterval(() => setSeconds((s) => s - 1), 1000);
    return () => clearInterval(id);
  }, [isActive, seconds]);

  // ── Machine actions ───────────────────────────────────────────────────────
  const OnMachine  = useCallback((vmId) => apiPost("/vm/on",  { user_id: selectedUser.id, vm_id: vmId }).then(GetMachines), [selectedUser?.id, apiPost, GetMachines]);
  const OffMachine = useCallback((vmId) => apiPost("/vm/off", { user_id: selectedUser.id, vm_id: vmId }).then(GetMachines), [selectedUser?.id, apiPost, GetMachines]);

  const toggleSwitch = useCallback(({ id, status }) =>
    status === "on" ? OnMachine(id) : OffMachine(id), [OnMachine, OffMachine]);

  const VMC = useCallback(async (vmId) => {
    setLoading(true);
    try {
      const res = await instance.post("vm/vnc", { user_id: selectedUser.id, vm_id: vmId });
      if (res.data.status) { window.location.href = res.data.url; }
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [selectedUser?.id]);

  const deleteMachine = useCallback(async (machineId) => {
    setDeletingMachine(machineId.vm_id);
    showToast("Your machine deletion process has been started!");
    try {
      const data = await apiPost("/vm/distroy", { user_id: selectedUser.id, vm_id: machineId.vm_id, id: machineId.id });
      if (data.status) GetMachines();
      else showToast("Unable To Delete Machine Please Try Again Later!");
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [selectedUser?.id, apiPost, GetMachines, showToast]);

  const RebuildMachine = useCallback(async (item) => {
    if (!item) { showToast("Oops! Your wallet balance is low, Please Add Money to create machine"); return; }
    setLoading(true);
    const payload = { user_id: selectedUser.id, request_id: item.request_id, machine_price: item.machine_o_rate, plan_time: item.plan_time, vm_template: item.vm_template, osiddata: item.osiddata, name: item.vm_name, cpu: item.cpu, ram: item.ram, hard_disk: item.hard_disk, data_transfer: item.data_transfer };
    try {
      await apiPost("/vm/rebuild_new", payload);
      if (selectedUser.platform_status === "1") window.location.href = "/vm-machine";
      else setTimeout(() => { window.location.href = "/vm-machine"; setLoading(false); }, 3000);
    } catch { showToast("Oops! Something went wrong while fetching the data. Please try again later or contact support if the issue persists."); }
    setLoading(false);
  }, [selectedUser, apiPost, showToast]);

  const slaManagement = useCallback(async (machineId) => {
    setLoading(true);
    try {
      const data = await apiPost("/slamgnt", { user_id: selectedUser.id });
      if (data.status) { setShowTermsCondition(true); setSLADesc(data.sla); setSLAid(data.sla_id); setMyMachineId(machineId); }
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [selectedUser?.id, apiPost]);

  const agreeSLAPdf = useCallback(async (machineid) => {
    setLoading(true);
    try {
      const data = await apiPost("/termsaccept", { user_id: selectedUser.id, vm_id: machineid, sla_id: slaId, finger_print: window.navigator.userAgent });
      if (data.success) { GetMachines(); showToast("SLA terms accepted successfully."); }
      else showToast(data.message);
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [selectedUser?.id, slaId, apiPost, GetMachines, showToast]);

  // ── SLA guard — reused pattern for every guarded action ──────────────────
  const withSLA = useCallback((item, onReady) => {
    if (!item.vm_id) return;
    if (item.sla_status === 1) {
      if (item.current_action_status === "PROCESSING") showToast(PROCESSING_MSG);
      else onReady();
    } else {
      if (!isProfileVerified) navigate("/edit-profile");
      else if (item.public_ip !== null) slaManagement(item.vm_id);
      else showToast(PROCESSING_MSG);
    }
  }, [isProfileVerified, navigate, slaManagement, showToast]);

  // ── Filter machines ───────────────────────────────────────────────────────
  const filterByLocation = useCallback((arr, loc) =>
    loc === "Global" ? arr : arr.filter((i) => i.location === loc), []);

  const visibleMachines = useMemo(() => {
    if (!machineData) return [];
    const base = isMobile ? machineData : filterByLocation(machineData, dropdownValue);
    return base.filter((i) => i.vm_name.toLowerCase().includes(searchText.toLowerCase()));
  }, [machineData, isMobile, dropdownValue, searchText, filterByLocation]);

  // ── Machine card (shared between mobile + web) ────────────────────────────
  const renderCard = useCallback((item, idx) => {
    const isProcessing = item.current_action_status === "PROCESSING";
    const isFailed     = item.current_action_status === "Failed";
    const vmLabel      = item.vm_status === 0 && !isFailed && !shownOnce ? "Standard" : vmCategoryLabel(item);

    return (
      <div className="box" key={item.vm_id ?? idx} style={{ marginRight: isMobile ? 0 : 15, marginTop: 40 }}>
        <div style={{ padding: "20px 0px", position: "relative", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", zIndex: 1 }}>
          <img src="/images/admin/01-home/server.svg" className="bg-image" style={{ position: "absolute", width: "100%", height: isMobile ? "100%" : "105%", left: 0, right: 0, top: 0, zIndex: -1 }} />

          {/* Network suspended badge */}
          {machineData?.[idx]?.nw_suspended !== 0 && (
            <div style={{ position: "relative" }}>
              <img src={isMobile ? "./i-icon.png" : "./no-wifi.png"} alt="" style={{ width: 25, height: 25, position: "absolute", top: isMobile ? 35 : 25, left: -110, cursor: "pointer" }}
                onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} />
              {isHovered && <div style={{ position: "absolute", top: -15, left: -110, backgroundColor: "#035189", color: "white", padding: 5, border: "1px solid #035189", borderRadius: 3, zIndex: 10 }}>{machineData[idx].nw_suspended_msg}</div>}
            </div>
          )}

          {/* VMC / status icon */}
          {item.vm_id === deletingMachine ? (
            <div><div className="loader-delete" style={{ position: "relative", left: isMobile ? 95 : 90, top: isMobile ? 12 : 25, border: "none" }} /></div>
          ) : item.vm_id === null ? (
            <img src="./i-icon.png" alt="" style={{ width: 25, height: 25 }} />
          ) : isProcessing ? (
            <div className="loader-vnc" style={{ position: "relative", height: isMobile ? 10 : 15, width: isMobile ? 20 : 30, left: isMobile ? 90 : 90, top: isMobile ? 0 : 40, border: "none", backgroundColor: isMobile ? "transparent" : "grey" }} />
          ) : isFailed ? (
            machineUser?.force_status === 1
              ? <button style={{ position: "relative", left: 100, border: "none", backgroundColor: "transparent" }} onClick={() => RebuildMachine(item)}><img src="./refresh.png" alt="" style={{ width: 25, height: 25 }} /></button>
              : <img src="./i-icon.png" alt="" style={{ width: 25, height: 25 }} />
          ) : (
            (!isMobile || true) && item.vnc_status && item.vnc_status !== 0 ? (
              <button style={{ position: "relative", left: 100, top: isMobile ? 0 : 25, border: "none", backgroundColor: "transparent" }}
                onClick={() => withSLA(item, () => VMC(item.vm_id))}>
                <img src="./vmc-monitor.png" alt="" style={{ width: 25, height: 25 }} />
              </button>
            ) : null
          )}

          {/* Machine icon + label */}
          <div className="machine-icon cpu-icon" style={{ marginTop: isMobile ? -60 : -25, marginLeft: isMobile ? 40 : 0 }}>
            <div className={isMobile ? "in-border" : "machine-icon-edit-profile"}
              style={isMobile ? { marginLeft: 12, alignContent: "center", height: 100, width: 100, border: "2px solid #E97730", borderRadius: "50%", backgroundColor: "transparent", padding: 0 }
                           : { marginLeft: 33, width: 94, height: 94 }}>
              {isMobile ? (
                <div className="in-border" style={{ height: 80, width: 80, padding: "1px 1px 1px 12px", border: "2px solid #E97730", borderRadius: "50%", margin: "auto", backgroundColor: "#E97730" }}>
                  <figure style={{ background: "#e9773000", borderRadius: "50%", padding: "20px 8px 0px 0px", display: "table", margin: "auto" }}>
                    {item.vm_status === 0 && !shownOnce
                      ? <div className="loader-machine-make" style={{ width: 77, marginTop: -22, marginLeft: -12 }} />
                      : <img src="/images/admin/01-home/cpu.svg" alt="" style={{ width: 40, height: 40 }} />}
                  </figure>
                </div>
              ) : (
                item.vm_status === 0 && !isFailed && !shownOnce
                  ? <div className="loader-machine-make" style={{ width: 94 }} />
                  : <img src="/images/admin/01-home/cpu.svg" alt="" style={{ width: 40, height: 40 }} />
              )}
            </div>

            {isMobile ? (
              <Button style={{ marginTop: -2, width: 120, height: 35, marginLeft: 10, backgroundColor: "transparent", border: "3px solid rgb(233,119,48)", borderRadius: 25 }}>
                <h4 style={{ color: "white", backgroundColor: "rgb(233,119,48)", paddingTop: 4, borderRadius: 15, height: 25, marginTop: -3, fontSize: 14, fontWeight: 700, marginLeft: -12, width: 110 }}>{vmLabel}</h4>
              </Button>
            ) : (
              <div className="machine-titles theme-bg-orange" style={{ width: 140 }}>{vmLabel}</div>
            )}
          </div>

          <div className="machine-name theme-color-blue" style={{ marginTop: isMobile ? -15 : 10 }}>{item.vm_name}</div>
          <div className="machine-config-badge" style={{ color: "white" }}>
            {item.ram / 1024} GB / {isMobile ? item.hard_disk : diskGB(item)} GB / {item.cpu} vCPU(s)
          </div>
          <div className="line-shape" style={{ width: "95%", height: 2, borderRadius: "50%", marginTop: 10, background: "linear-gradient(90deg, rgba(190,190,190,0), rgba(190,190,190,1), rgba(190,190,190,0))" }} />

          <IpField label="Location"   value={item.location} />
          <IpField label="Public IP"  value={item.public_ip} />
          <IpField label="Private IP" value={item.ip_address} />
          <div className="machine-date" style={{ marginTop: 8 }}>Created:{item.created_at}</div>

          {/* Actions */}
          <div className="actions" style={{ paddingLeft: 20, marginTop: -4, marginBottom: isMobile ? 10 : 0, display: "flex", justifyContent: "space-around" }}>
            <ActionBtn label="View Status" dimOnProcessing isProcessing={isProcessing}
              onClick={() => withSLA(item, () => {
                if (!isProcessing && !isFailed) navigate("/vm/status", { state: { vmDetails: item.vm_id } });
                else showToast(PROCESSING_MSG);
              })} />
            <ActionBtn label="Monitor" isPublicIpNull={item.public_ip === null}
              onClick={() => withSLA(item, () => {
                if (!isProcessing && !isFailed) navigate("/vm/moniter/utilize", { state: { vm_data: item.vm_id } });
                else showToast(PROCESSING_MSG);
              })} />
          </div>

          {/* Toggle + Edit + Delete */}
          <div className="actions" style={{ marginTop: -1 }}>
            <div className="icons log-in" style={isMobile ? undefined : { gap: 15 }}>
              <div className={`switch ${item.status === 1 ? "on" : "off"}`}
                style={isMobile ? { marginTop: -25, marginLeft: -110 } : undefined}
                onClick={() => withSLA(item, () => {
                  if (!isProcessing && !isFailed) toggleSwitch({ id: item.vm_id, status: item.status === 1 ? "off" : "on" });
                  else showToast(PROCESSING_MSG);
                })}>
                <div className="toggle" />
                <div className="labels"><span>ON</span><span>OFF</span></div>
              </div>

              {!isMobile && (
                <>
                  <button disabled={item.public_ip === null} style={{ border: "none", backgroundColor: "transparent" }}
                    onClick={() => withSLA(item, () => { if (!isProcessing) { setEditMachineId(item.vm_id); SetEditPopup(true); } else showToast(PROCESSING_MSG); })}>
                    <a><img src="/images/admin/01-home/edit.svg" /></a>
                  </button>
                  <button style={{ border: "none", backgroundColor: "transparent" }}
                    onClick={() => withSLA(item, () => { if (!isProcessing) { SetDeletePopup(true); setMachineToDelete({ vm_id: item.vm_id, id: item.id }); } else showToast(PROCESSING_MSG); })}>
                    <a className="delete"><img src="/images/admin/01-home/delete.svg" /></a>
                  </button>
                </>
              )}

              {isMobile && (
                <div className="icons log-in">
                  <div style={{ marginLeft: 55, marginBottom: -15, marginRight: 15 }}
                    onClick={() => withSLA(item, () => { if (!isProcessing) { setEditMachineId(item.vm_id); SetEditPopup(true); } else showToast(PROCESSING_MSG); })}>
                    <img src="/images/admin/01-home/edit.svg" />
                  </div>
                  <div style={{ marginBottom: -5, marginRight: -30 }}
                    onClick={() => withSLA(item, () => { if (!isProcessing) { SetDeletePopup(true); setMachineToDelete({ vm_id: item.vm_id, id: item.id }); } else showToast(PROCESSING_MSG); })}>
                    <img src="/images/admin/01-home/delete.svg" />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }, [isMobile, machineData, machineUser, deletingMachine, isHovered, shownOnce, withSLA, VMC, RebuildMachine, toggleSwitch, navigate, showToast]);

  // ─── Render ────────────────────────────────────────────────────────────────
  return (
    <div style={{ width: "100%", minHeight: "65rem", position: "relative", backgroundImage: "url(./main-bg.jpg)", backgroundSize: "cover", backgroundRepeat: "round", backgroundBlendMode: "overlay" }}>
      {loading && <div className="loading-overlay" style={{ zIndex: 99999999999999 }}><Loader isLoading={loading} /></div>}

      {/* SLA Terms popup */}
      {showTermsCondition && (
        <div style={{ display: "grid", justifyItems: "center" }}>
          <div style={{ backgroundImage: "url(/main-bg.jpg)", backgroundSize: "cover", top: "10%", position: "absolute", zIndex: 99, width: isMobile ? "90%" : "35%", backdropFilter: "blur(5px)", height: "35rem", borderRadius: 12, border: "2px solid #e97730" }}>
            <div style={{ display: "grid", justifyItems: "center" }}>
              <button style={{ color: "#035189", position: "absolute", right: 0, border: "none", backgroundColor: "transparent", width: 20, height: 20 }} onClick={() => setShowTermsCondition(false)}>X</button>
              <h4 style={{ marginTop: 10 }}>SLA Agreement</h4>
              <div style={{ height: "25rem", overflowY: "scroll", padding: 30, borderRadius: 8, border: "1px solid #e97730" }}>
                <p>{slaDesc}</p>
              </div>
              <button style={{ color: "white", width: "8rem", height: 40, backgroundColor: "#035189", borderRadius: 25, border: "2px solid #ffff", outline: "2px solid #035189", marginTop: 25 }}
                onClick={() => { setShowTermsCondition(false); agreeSLAPdf(myMachineId); }}>
                I AGREE
              </button>
            </div>
          </div>
        </div>
      )}

      {isMobile ? (
        /* ── MOBILE ──────────────────────────────────────────────────────── */
        <div style={{ height: "50rem" }}>
          {vncPopup    && <VNCPopup vNCinfo={vNCinfo} isMobile onClose={() => SetVncPopup(false)} />}
          <div className="heading-dotted-machine">VM List <span /></div>

          {machineData?.length > 0 ? (
            <>
              {editPopup   && <EditPopup isMobile onClose={() => SetEditPopup(false)}
                onEditOS={()     => navigate("/edit-vm", { state: { machineData: editMachineId, editType: "os" } })}
                onEditConfig={()  => navigate("/edit-vm", { state: { machineData: editMachineId, editType: "config" } })} />}
              {deletePopup && <DeletePopup isMobile onConfirm={() => { SetDeletePopup(false); deleteMachine(machineToDelete); }} onCancel={() => SetDeletePopup(false)} />}
              <SearchBar value={searchText} onChange={setSearchText} isMobile />
              <div className="wallet-container" style={{ border: "none" }}>
                <div className="wallet-box">{visibleMachines.map((item, idx) => renderCard(item, idx))}</div>
              </div>
            </>
          ) : showPlaceholder && (
            <div style={{ position: "absolute", top: "30%", left: "30%" }}>
              <figure style={{ width: 100, height: 100, background: "rgb(233,119,48)", borderRadius: "50%", margin: "auto", padding: 20, outline: "3px solid rgb(233,119,48)", border: "5px solid white" }}>
                <img src="/admin/images/admin/menu/vm-white.png" alt="" style={{ marginLeft: -5, width: 60, height: 60 }} />
              </figure>
              <button className="create-new-machine" onClick={() => navigate("/vm/create")}>Create Machine</button>
            </div>
          )}
        </div>
      ) : (
        /* ── WEB ─────────────────────────────────────────────────────────── */
        <>
          <div className="heading-dotted-machine" style={{ left: "5%", paddingTop: "4%" }}>
            VM List <span />
            {selectedUser && (
              <Button style={{ background: "#035189", border: "none", fontSize: 20, padding: "5px 15px", color: "#fff", fontWeight: 400, marginBottom: 10 }}>
                {selectedUser.name}, {selectedUser.email}
              </Button>
            )}
          </div>

          <div className="features-page-solution" style={{ height: "100%", marginTop: "-5rem", paddingLeft: "5rem" }}>
            {vncPopup && <VNCPopup vNCinfo={vNCinfo} isMobile={false} onClose={() => SetVncPopup(false)} />}
            <SearchBar value={searchText} onChange={setSearchText} isMobile={false} />

            <div className="features-section-solution">
              <Row>
                <div className="col-md-1" />
                <div className="col-md-10">
                  {machineData?.length > 0 ? (
                    <>
                      {editPopup   && <EditPopup isMobile={false} onClose={() => SetEditPopup(false)}
                        onEditOS={()    => navigate("/edit-vm", { state: { machineData: editMachineId, editType: "os" } })}
                        onEditConfig={() => navigate("/edit-vm", { state: { machineData: editMachineId, editType: "config" } })} />}
                      {deletePopup && <DeletePopup isMobile={false} onConfirm={() => { SetDeletePopup(false); deleteMachine(machineToDelete); }} onCancel={() => SetDeletePopup(false)} />}
                      <div className="wallet-container" style={{ border: "none", marginLeft: 30 }}>
                        <div className="wallet-box" style={{ justifyContent: "unset", alignContent: "flex-start", flexDirection: "row", flexWrap: "wrap", display: "flex", gap: 20 }}>
                          {visibleMachines.map((item, idx) => renderCard(item, idx))}
                        </div>
                      </div>
                    </>
                  ) : showPlaceholder && (
                    <div style={{ position: "absolute", top: "30%", left: "48%" }}>
                      <figure style={{ width: 100, height: 100, background: "rgb(233,119,48)", borderRadius: "50%", margin: "auto", padding: 20, outline: "3px solid rgb(233,119,48)", border: "5px solid white" }}>
                        <img src="/admin/images/admin/menu/vm-white.png" alt="" style={{ marginLeft: -5, width: 60, height: 60 }} />
                      </figure>
                      <button style={{ width: "13rem", marginTop: 2, zIndex: 9, position: "relative", fontWeight: 700, color: "white", height: 55, backgroundColor: "#e97730", outline: "4px solid #e97730", border: "4px solid white", borderRadius: 30 }}>
                        No Machines Assigned
                      </button>
                    </div>
                  )}
                </div>
                <div className="col-md-1" />
              </Row>
            </div>
          </div>
        </>
      )}

      <div className="apptoast-align">
        <Toaster position={isMobile ? "top-center" : "bottom-right"} reverseOrder={false} />
      </div>
    </div>
  );
};

export default AssignedMachinePage;